"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InsightsScene = void 0;

var React = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var routes = _interopRequireWildcard(require("../../../utils/routes"));

var _reactRedux = require("react-redux");

var _Page = require("../../../components/Layout/Page");

var _selections = require("../../../redux/modules/_BETA/selections");

var _actionCreators = require("../../../redux/modules/urlHistory/actionCreators");

var _analysis = require("../../../context/analysis");

var _useActions = require("../../../context/insights/useActions");

var _Insights = require("../../../components/Analysis/Insights");

var _SubNav = require("../../../components/Analysis/SubNav");

var _useInsightsEffects = require("../hooks/useInsightsEffects");

var _insights = require("../../../context/insights");

var _InsightEquips = _interopRequireDefault(require("../InsightEquips"));

// global
// hooks and state
// component
const equipViewRE = /\/analysis\/(:?insights|monitoring)\/(.+)\/\d+/;
const ShowHideLayer = _styledComponents.default.div`
  display: ${props => props.isVisible ? 'block' : 'none'};
`;

function mapStateToProps(state) {
  return {
    appReady: state.appSetup.appSetupComplete,
    timeRange: state.betaSelections.daysRange,
    hasPermission: state.auth.user.access != null && state.auth.user.access.includes('viewTriagePage'),
    selectedSites: state.betaSelections.selectedSites,
    shouldRequestInsights: state.requestSchedule.shouldRequestInsights,
    sites: state.userSites.sites,
    projects: state.userSites.projects,
    showSnoozed: state.insights.showSnoozed
  };
}

const mapDispatchToProps = {
  updateDaysRange: _selections.updateDaysRange,
  updateInsightsUrlHistory: _actionCreators.updateInsightsUrlHistory,
  setMultiSite: _selections.updateIsMultiSiteRoute
};

const InsightsSceneFC = ({
  appReady,
  hasPermission,
  timeRange,
  selectedSites,
  sites,
  projects,
  updateDaysRange,
  shouldRequestInsights,
  setMultiSite,
  history,
  showSnoozed
}) => {
  if (!appReady) return null;
  if (!hasPermission) return /*#__PURE__*/React.createElement(_reactRouterDom.Redirect, {
    to: "/actions"
  });
  const [scrollPos, setScrollPos] = React.useState(0);
  const isEquipView = equipViewRE.exec(window.location.pathname) !== null;
  const handleScroll = (0, _lodash.default)(() => {
    if (!isEquipView) {
      setScrollPos(window.scrollY);
    }
  }, 300);
  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });
  React.useEffect(() => {
    if (!isEquipView) {
      window.requestIdleCallback(() => window.scroll(0, scrollPos));
    }
  }, [isEquipView]);
  const {
    setCategory
  } = (0, _useActions.useActions)();
  const {
    setViewMode
  } = (0, _analysis.useActions)();
  const [state] = (0, _insights.useInsights)();
  (0, _useInsightsEffects.useInsightsEffects)(timeRange, selectedSites, shouldRequestInsights, sites, projects);
  React.useEffect(() => {
    setViewMode('insights');
  });
  React.useEffect(() => {
    setMultiSite(!isEquipView);
  }, [selectedSites, isEquipView]);
  const onChangeCategory = React.useCallback(category => {
    setCategory(history, category);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactHelmet.default, {
    title: "Insights"
  }), /*#__PURE__*/React.createElement(ShowHideLayer, {
    isVisible: !isEquipView
  }, /*#__PURE__*/React.createElement(_SubNav.SubNav, {
    category: state.category,
    onChangeCategory: onChangeCategory
  }), /*#__PURE__*/React.createElement(_Page.Wrap, {
    className: "Insights-ListScene"
  }, /*#__PURE__*/React.createElement(_Insights.Insights, {
    history: history,
    updateHistory: _actionCreators.updateInsightsUrlHistory,
    updateTimeRange: updateDaysRange,
    timeRange: timeRange,
    showSnoozed: showSnoozed
  }))), /*#__PURE__*/React.createElement(_reactRouterDom.Route, {
    exact: true,
    path: routes.INSIGHT_EQUIPS,
    component: _InsightEquips.default
  }));
};

const InsightsScene = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InsightsSceneFC);
exports.InsightsScene = InsightsScene;